import React from "react";
import {LinearProgress} from "@material-ui/core";

const VIEW_LOADER_STYLES = {bottom: 0, left: 0, position: "fixed", width: "100%", zIndex: 10000000};

export default () => <LinearProgress style={VIEW_LOADER_STYLES} />;
